import { useEffect, useState } from "react";
import { BsXLg } from "react-icons/bs";
import { useForm } from "react-final-form";
import { User } from "../../../interfaces/interfaces";
import { UsersRestS } from "../../../rest/users-rest-service";
import styles from "./AddGroupMembers.module.scss";

export default function AddGroupMembers({ members, setMembers, onClose }) {
  const [userList, setUserList] = useState([]);
  const [selectedUsersId, setSelectedUserId] = useState([]);
  const [selectedUsers, setSelectedUser] = useState<User[]>();
  const { getFieldState, change, mutators } = useForm();

  useEffect(() => {
    UsersRestS.getUsersByCompany()
      .then((res) => {
        setUserList(res);
      })
      .catch((e) => console.error(e));
    let ids = members?.map((u) => u.id);
    const membersFieldState = getFieldState("members").value;
    //
    if (membersFieldState !== undefined && membersFieldState.length > 0) {
      //
      let ids = membersFieldState?.map((u) => u.id);
      setSelectedUserId(ids);
      setSelectedUser(membersFieldState);
    } else {
      setSelectedUserId([]);
      setSelectedUser([]);
    }
  }, []);

  // useEffect(() => {

  // }, [getFieldState('members')])

  const changeSelection = (val) => {
    if (selectedUsersId.includes(val.id)) {
      let users = selectedUsers.filter((e) => e.id != val.id);

      let ids = selectedUsersId.filter((e) => e != val.id);
      setSelectedUser([...users]);
      setSelectedUserId([...ids]);
    } else {
      setSelectedUser([...selectedUsers, val]);
      setSelectedUserId([...selectedUsersId, val.id]);
    }
  };

  const doneButton = () => {
    // setMembers(selectedUsers);
    //
    change("members", selectedUsers);
    onClose();
  };

  return (
    <div className={styles.addUserPannel}>
      <div className={styles.addMembersDiv}>
        <div className={styles.header}>
          <div className={styles.heading}>Add members to group</div>
          <div className={`${styles.icon}`} onClick={onClose}>
            <BsXLg size="1rem" />
          </div>
        </div>
        <div className={styles.addMembersBlock}>
          {userList &&
            userList.map((user: User, index) => {
              return (
                <div
                  className={styles.membersList}
                  key={index}
                  onClick={() => {
                    const membersFieldTouchedState =
                      getFieldState("members").touched;
                    if (!membersFieldTouchedState) {
                      mutators.setFieldTouched("members", true);
                    }
                    changeSelection(user);
                  }}
                >
                  {/* <Input className={styles.checkBox} type="checkbox" checked={selectedUsersId.includes(user.id)} onClick={() => changeSelection(user)} onChange={() => { }} key={`${user.id},${selectedUsers.includes(user)}`} /> */}
                  <div className={styles.customSelect}>
                    {selectedUsersId.includes(user.id) ? (
                      <div className={styles.innerSelect}></div>
                    ) : null}
                  </div>

                  <div className={styles.membersInfo}>
                    <div
                      style={{
                        backgroundColor: user.color
                          ? `#${user.color}`
                          : "#596de7",
                        cursor: "pointer",
                      }}
                      className={`${styles.profileImage}`}
                    >
                      {user.name.charAt(0).toUpperCase()}
                    </div>
                    <div className={styles.membersNameDesignation}>
                      <div className={styles.membersName}>{user.name}</div>
                      <div className={styles.membersDesignation}>
                        {user.designation}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <div className={styles.btns}>
          <button
            type="reset"
            className={styles.proceedBtn}
            onClick={doneButton}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
